export default "__VITE_ASSET__59a9be6d__"